const { gql } = require('@apollo/client')

const createFileType = gql(`
  mutation updateFileType(
    $project: String, 
    $input: UpdateFileTypeInput!
   ){
    updateFileType(
      input : $input
      project : $project
    ){
      id
      name
      isEnabled
      extension
    }
  }  
`)

export default createFileType
